import { BRANCHES } from 'app/api-routes';
import axios from 'axios';
import { all, put, takeLatest } from 'redux-saga/effects';
import {
  branchesFailure,
  branchesRequest,
  branchesSuccess,
  branchFailure,
  branchOptionsFailure,
  branchOptionsRequest,
  branchOptionsSuccess,
  branchRequest,
  branchSuccess,
  createBranchFailure,
  createBranchRequest,
  createBranchSuccess,
  updateBranchFailure,
  updateBranchRequest,
  updateBranchStatusFailure,
  updateBranchStatusRequest,
  updateBranchStatusSuccess,
  updateBranchSuccess,
} from './actions';

function* branchesSaga() {
  try {
    const { payload } = yield axios.get(BRANCHES);

    yield put(branchesSuccess(payload));
  } catch (err) {
    yield put(branchesFailure(err));
  }
}

function* branchSaga({ payload: branchID }) {
  try {
    const { payload } = yield axios.get(`${BRANCHES}/${branchID}`);

    yield put(branchSuccess(payload));
  } catch (err) {
    yield put(branchFailure(err));
  }
}

function* branchOptionsSaga() {
  try {
    const { payload } = yield axios.get(`${BRANCHES}/options`);

    yield put(branchOptionsSuccess(payload));
  } catch (err) {
    yield put(branchOptionsFailure(err));
  }
}

function* createBranchSaga({ payload, meta }) {
  try {
    const { payload: branchID } = yield axios.post(BRANCHES, { payload });

    yield put(createBranchSuccess(branchID));
    meta?.onSuccess?.(branchID);
  } catch (err) {
    yield put(createBranchFailure(err));
    meta?.onFailure?.(err);
  } finally {
    meta?.onFinally?.();
  }
}

function* updateBranchSaga({ payload: { payload, branchID }, meta }) {
  try {
    yield axios.put(`${BRANCHES}/${branchID}`, { payload });

    yield put(updateBranchSuccess({ branchID, payload }));
    meta?.onSuccess?.(branchID);
  } catch (err) {
    yield put(updateBranchFailure(err));
    meta?.onFailure?.(err);
  } finally {
    meta?.onFinally?.();
  }
}

function* updateBranchStatusSaga({ payload: { status, branchID }, meta }) {
  try {
    yield axios.put(`${BRANCHES}/${branchID}/status`, { payload: status });

    yield put(updateBranchStatusSuccess({ branchID, status }));
    meta?.onSuccess?.(branchID);
  } catch (err) {
    yield put(updateBranchStatusFailure(err));
    meta?.onFailure?.(err);
  } finally {
    meta?.onFinally?.();
  }
}

export default function* () {
  yield all([
    yield takeLatest(branchesRequest, branchesSaga),
    yield takeLatest(branchRequest, branchSaga),
    yield takeLatest(branchOptionsRequest, branchOptionsSaga),
    yield takeLatest(createBranchRequest, createBranchSaga),
    yield takeLatest(updateBranchRequest, updateBranchSaga),
    yield takeLatest(updateBranchStatusRequest, updateBranchStatusSaga),
  ]);
}
